<template>
  <div>
    <section class="main-QA">
      <div class="main-center container">
        <div class="t">
          <h2>FAQ</h2>
          <div class="more-btn">
            <a href="javascript:void(0)" @click="redrect2Url('faq')">Learn more <em>></em></a>
          </div>
        </div>
        <div class="content">
          <ul id="accordion1" class="accordion">
            <li>
              <div class="link">
                <h5><span>01. Registration Procedure </span> <i></i></h5>
              </div>
              <div class="submenu">
                <h6>1. How to register online? </h6>
                <p>Pay tuition - Select course - Course approval - Course registration - Sign the
                  agreement - Receive
                  student manual- Begin classes - Get grades - Send transcripts - Transfer credits</p>
              </div>
            </li>
            <li>
              <div class="link">
                <h5><span>02. Tuition/Fees</span> <i></i></h5>
              </div>
              <div class="submenu">
                <h6>1. What is the pricing?</h6>
                <p>All courses offered on LightCourse are priced individually based on the institution
                  offering the course. Please check the top right of the course page for specific
                  prices or contact your advisor for a one-on-one consultation.</p>
                <h6>2. What payment methods can I use?</h6>
                <p>LightCourse offers a variety of payment methods. Tuition can be paid in USD or RMB,
                  WeChat, Alipay, bank transfer, and PayPal transfer are all accepted.</p>
                <h6>3. What fees are included?</h6>
                <p>The course price, application fee, and file management charge are included in the
                  pricing. However, other fees—such as those covering course materials, third-party
                  platforms such as Cengage, Labster, and other course-related costs such as VPN,
                  accommodation, etc.—may apply. Contact your advisor for a one-on-one consultation.
                </p>
              </div>
            </li>

            <li>
              <div class="link">
                <h5><span>03. Select the Right Course(s) for You</span> <i></i></h5>
              </div>
              <div class="submenu">
                <h6>1. How do I choose the best program/course for me?</h6>
                <p>Throughout the year, LightCourse offers programs and courses from institutions around
                  the world in a variety of disciplines, including engineering, business, natural
                  sciences, social sciences, humanities, and arts. These courses are intended to meet
                  the needs of a wide range of students seeking major, elective, and general education
                  courses. There are a variety of study alternatives available, including online
                  for-credit courses (live/recorded/self-paced) and in-person courses, as well as
                  study abroad programs.
                </p>
                <p>LightCourse will provide you with an advisor who will work directly with you to help
                  determine the best options for your needs.</p>
                <p>(Note: Since all courses have limited capacity, we recommend registering as soon as
                  possible to ensure a spot.)</p>
              </div>
            </li>

            <li>
              <div class="link">
                <h5><span>04. Complete Course Approval</span> <i></i></h5>
              </div>
              <div class="submenu">
                <h6>1. Does my home school approve these courses?</h6>
                <p>LightCourse will provide you with an advisor who will provide you with one-on-one
                  support throughout the transfer process according to your university's transfer
                  credit policy to ensure that you can complete the credit transfer successfully.</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: {

    },
    data(){
      return{

      }
    },
    created() {

    },
    mounted() {
      $("#accordion1").accordion({ active: false, collapsible: true, animate: 0});
    },
    methods: {
      redrect2Url(path) {
        this.$router.push('/' + path);
      },
    }
  }
</script>

<style scoped>
    .main-QA .content .accordion li h5 span {
      font-weight: bold;
    }
    .main-QA .content .accordion li h6 {
      font-weight: bold;
    }
    .copy-btn-01,
    .copy-btn-02{
      transition: all .6s;
    }
    .copy-btn-01:hover,
    .copy-btn-02:hover{
      color: #00db6d !important;
    }
  .setBetween .item:nth-of-type(1):after {
    content: '';
    display: block;
    width: 1px;
    height: 100%;
    background: #3b52f6;
    position: absolute;
    right: 0;
    top: 0;
  }

  .setBetween .item {
    width: 50%;
  }

  .setBetween .item:nth-of-type(1) {
    padding-right: 20px !important;
    position: relative;
  }

  .setBetween .item:nth-of-type(2) {
    padding-right: 20px !important;
  }

  .setBetween .item:nth-of-type(1):after {
    width: 0px;
  }

  .a-line {
    padding-bottom: 0.8rem;
  }

  .a-btn {
    background: #3b52f6;
    /*display: inline-block;*/
    text-align: center;
    height: 3rem;
    line-height: 3rem;
    color: white;
  }

  .a-btn a {
    color: white !important;
    display: block;
    width: 100%;
    height: 100%;
  }

  .a-blue {
    color: #3b52f6;
  }

  .add-btn {
    text-align: right;
  }

  .add-btn a {
    border-radius: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/FaqFooter.vue